import catalogos from './catalogos'

const sicpe = {
    catalogos: catalogos
}

export default sicpe


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPE/catalogos/sicpe.js
// module id = null
// module chunks = 